// HR Module Routes Configuration
// Note: Using any[] to avoid vue-router type issues during development
import leaveAccrualRoutes from '../leavemanagement/leaveAccrual/routes';
import { leaveApprovalWorkflowRoutes } from '../leavemanagement/leaveApprovalWorkflow/routes';
import { leaveCalendarRoutes } from '../leavemanagement/leaveCalendar/routes';
import { leaveReportsRoutes } from '../leavemanagement/leaveReports/routes';

export const hrRoutes: any[] = [
  {
    path: '/hr',
    name: 'hr',
    redirect: { name: 'hrDashboard' },
    meta: {
      title: 'routes.hr',
      requiresAuth: true,
      breadcrumb: 'Human Resources'
    },
    children: [
      {
        path: 'dashboard',
        name: 'hrDashboard',
        component: () => import('@/modules/hr/dashboard/hrDashboard.vue'),
        meta: {
          title: 'routes.hrDashboard',
          requiresAuth: true,
          breadcrumb: 'HR Dashboard'
        }
      },

      // Master Tables Routes
      {
        path: 'mastertables',
        name: 'hrMasterTables',
        redirect: { name: 'designationMaster' },
        meta: {
          title: 'routes.hrMasterTables',
          requiresAuth: true,
          breadcrumb: 'Master Tables'
        },
        children: [
          // Designation Master Routes
          {
            path: 'designation',
            name: 'designationMaster',
            component: () => import('@/modules/hr/mastertables/designationMaster/components/DesignationMasterList.vue'),
            meta: {
              title: 'routes.designationMaster',
              requiresAuth: true,
              permission: 'hr.designation.view',
              breadcrumb: 'Designation Master'
            }
          },
          {
            path: 'designation/add',
            name: 'addDesignation',
            component: () => import('@/modules/hr/mastertables/designationMaster/components/DesignationMasterForm.vue'),
            meta: {
              title: 'routes.addDesignation',
              requiresAuth: true,
              permission: 'hr.designation.create',
              breadcrumb: 'Add Designation'
            }
          },
          {
            path: 'designation/:id/edit',
            name: 'editDesignation',
            component: () => import('@/modules/hr/mastertables/designationMaster/components/DesignationMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editDesignation',
              requiresAuth: true,
              permission: 'hr.designation.edit',
              breadcrumb: 'Edit Designation'
            }
          },
          {
            path: 'designation/hierarchy',
            name: 'designationHierarchy',
            component: () => import('@/modules/hr/mastertables/designationMaster/components/DesignationHierarchyView.vue'),
            meta: {
              title: 'routes.designationHierarchy',
              requiresAuth: true,
              permission: 'hr.designation.view',
              breadcrumb: 'Designation Hierarchy'
            }
          },

          // Grade Master Routes
          {
            path: 'grade',
            name: 'gradeMaster',
            component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterList.vue'),
            meta: {
              title: 'routes.gradeMaster',
              requiresAuth: true,
              permission: 'hr.grade.view',
              breadcrumb: 'Grade Master'
            }
          },
          {
            path: 'grade/add',
            name: 'addGrade',
            component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterForm.vue'),
            meta: {
              title: 'routes.addGrade',
              requiresAuth: true,
              permission: 'hr.grade.create',
              breadcrumb: 'Add Grade'
            }
          },
          {
            path: 'grade/:id/edit',
            name: 'editGrade',
            component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editGrade',
              requiresAuth: true,
              permission: 'hr.grade.edit',
              breadcrumb: 'Edit Grade'
            }
          },
          {
            path: 'grade/:id/view',
            name: 'viewGrade',
            component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.viewGrade',
              requiresAuth: true,
              permission: 'hr.grade.view',
              breadcrumb: 'View Grade'
            }
          },

          // Employment Type Master Routes
          {
            path: 'employmenttype',
            name: 'employmentTypeMaster',
            component: () => import('@/modules/hr/mastertables/employmentTypeMaster/components/EmploymentTypeMasterList.vue'),
            meta: {
              title: 'routes.employmentTypeMaster',
              requiresAuth: true,
              permission: 'hr.employmentType.view',
              breadcrumb: 'Employment Type Master'
            }
          },
          {
            path: 'employmenttype/add',
            name: 'addEmploymentType',
            component: () => import('@/modules/hr/mastertables/employmentTypeMaster/components/EmploymentTypeMasterForm.vue'),
            meta: {
              title: 'routes.addEmploymentType',
              requiresAuth: true,
              permission: 'hr.employmentType.create',
              breadcrumb: 'Add Employment Type'
            }
          },
          {
            path: 'employmenttype/:id/edit',
            name: 'editEmploymentType',
            component: () => import('@/modules/hr/mastertables/employmentTypeMaster/components/EmploymentTypeMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editEmploymentType',
              requiresAuth: true,
              permission: 'hr.employmentType.edit',
              breadcrumb: 'Edit Employment Type'
            }
          },

          // Leave Type Master Routes
          {
            path: 'leavetype',
            name: 'leaveTypeMaster',
            component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterList.vue'),
            meta: {
              title: 'routes.leaveTypeMaster',
              requiresAuth: true,
              permission: 'hr.leaveType.view',
              breadcrumb: 'Leave Type Master'
            }
          },
          {
            path: 'leavetype/add',
            name: 'addLeaveType',
            component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterForm.vue'),
            meta: {
              title: 'routes.addLeaveType',
              requiresAuth: true,
              permission: 'hr.leaveType.create',
              breadcrumb: 'Add Leave Type'
            }
          },
          {
            path: 'leavetype/:id/edit',
            name: 'editLeaveType',
            component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editLeaveType',
              requiresAuth: true,
              permission: 'hr.leaveType.edit',
              breadcrumb: 'Edit Leave Type'
            }
          },
          {
            path: 'leavetype/:id/view',
            name: 'viewLeaveType',
            component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterView.vue'),
            props: true,
            meta: {
              title: 'routes.viewLeaveType',
              requiresAuth: true,
              permission: 'hr.leaveType.view',
              breadcrumb: 'View Leave Type'
            }
          },

          // Exit Type Master Routes
          {
            path: 'exittype',
            name: 'exitTypeMaster',
            component: () => import('@/modules/hr/mastertables/exitTypeMaster/components/ExitTypeMasterList.vue'),
            meta: {
              title: 'routes.exitTypeMaster',
              requiresAuth: true,
              permission: 'hr.exitType.view',
              breadcrumb: 'Exit Type Master'
            }
          },
          {
            path: 'exittype/add',
            name: 'addExitType',
            component: () => import('@/modules/hr/mastertables/exitTypeMaster/components/ExitTypeMasterForm.vue'),
            meta: {
              title: 'routes.addExitType',
              requiresAuth: true,
              permission: 'hr.exitType.create',
              breadcrumb: 'Add Exit Type'
            }
          },
          {
            path: 'exittype/:id/edit',
            name: 'editExitType',
            component: () => import('@/modules/hr/mastertables/exitTypeMaster/components/ExitTypeMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editExitType',
              requiresAuth: true,
              permission: 'hr.exitType.edit',
              breadcrumb: 'Edit Exit Type'
            }
          },
          {
            path: 'exittype/:id/view',
            name: 'viewExitType',
            component: () => import('@/modules/hr/mastertables/exitTypeMaster/components/ExitTypeMasterView.vue'),
            props: true,
            meta: {
              title: 'routes.viewExitType',
              requiresAuth: true,
              permission: 'hr.exitType.view',
              breadcrumb: 'View Exit Type'
            }
          },

          // Onboarding Template Master Routes
          {
            path: 'onboardingtemplatemaster',
            name: 'onboardingTemplateMaster',
            component: () => import('@/modules/hr/mastertables/onboardingTemplateMaster/components/OnboardingTemplateMasterList.vue'),
            meta: {
              title: 'routes.onboardingTemplateMaster',
              requiresAuth: true,
              permission: 'hr.onboardingTemplate.view',
              breadcrumb: 'Onboarding Template Master'
            }
          },
          {
            path: 'onboardingtemplatemaster/add',
            name: 'addOnboardingTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTemplateMaster/components/OnboardingTemplateMasterForm.vue'),
            meta: {
              title: 'routes.addOnboardingTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTemplate.create',
              breadcrumb: 'Add Onboarding Template'
            }
          },
          {
            path: 'onboardingtemplatemaster/:id/edit',
            name: 'editOnboardingTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTemplateMaster/components/OnboardingTemplateMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTemplate.edit',
              breadcrumb: 'Edit Onboarding Template'
            }
          },
          {
            path: 'onboardingtemplatemaster/:id/view',
            name: 'viewOnboardingTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTemplateMaster/components/OnboardingTemplateMasterView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTemplate.view',
              breadcrumb: 'View Onboarding Template'
            }
          },

          // Onboarding Task Template Routes
          {
            path: 'onboardingtasktemplate',
            name: 'onboardingTaskTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTaskTemplate/components/OnboardingTaskTemplateList.vue'),
            meta: {
              title: 'routes.onboardingTaskTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTaskTemplate.view',
              breadcrumb: 'Onboarding Task Template'
            }
          },
          {
            path: 'onboardingtasktemplate/add',
            name: 'addOnboardingTaskTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTaskTemplate/components/OnboardingTaskTemplateForm.vue'),
            meta: {
              title: 'routes.addOnboardingTaskTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTaskTemplate.create',
              breadcrumb: 'Add Onboarding Task Template'
            }
          },
          {
            path: 'onboardingtasktemplate/:id/edit',
            name: 'editOnboardingTaskTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTaskTemplate/components/OnboardingTaskTemplateForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingTaskTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTaskTemplate.edit',
              breadcrumb: 'Edit Onboarding Task Template'
            }
          },
          {
            path: 'onboardingtasktemplate/:id/view',
            name: 'viewOnboardingTaskTemplate',
            component: () => import('@/modules/hr/mastertables/onboardingTaskTemplate/components/OnboardingTaskTemplateView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingTaskTemplate',
              requiresAuth: true,
              permission: 'hr.onboardingTaskTemplate.view',
              breadcrumb: 'View Onboarding Task Template'
            }
          },

          // // Department Master Routes
          // {
          //   path: 'department',
          //   name: 'departmentMaster',
          //   component: () => import('@/modules/hr/mastertables/departmentMaster/components/DepartmentMasterList.vue'),
          //   meta: {
          //     title: 'routes.departmentMaster',
          //     requiresAuth: true,
          //     permission: 'hr.department.view',
          //     breadcrumb: 'Department Master'
          //   }
          // },
          // {
          //   path: 'department/add',
          //   name: 'addDepartment',
          //   component: () => import('@/modules/hr/mastertables/departmentMaster/components/DepartmentMasterForm.vue'),
          //   meta: {
          //     title: 'routes.addDepartment',
          //     requiresAuth: true,
          //     permission: 'hr.department.create',
          //     breadcrumb: 'Add Department'
          //   }
          // },
          // {
          //   path: 'department/:id/edit',
          //   name: 'editDepartment',
          //   component: () => import('@/modules/hr/mastertables/departmentMaster/components/DepartmentMasterForm.vue'),
          //   props: true,
          //   meta: {
          //     title: 'routes.editDepartment',
          //     requiresAuth: true,
          //     permission: 'hr.department.edit',
          //     breadcrumb: 'Edit Department'
          //   }
          // },

          // // Grade Master Routes
          // {
          //   path: 'grade',
          //   name: 'gradeMaster',
          //   component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterList.vue'),
          //   meta: {
          //     title: 'routes.gradeMaster',
          //     requiresAuth: true,
          //     permission: 'hr.grade.view',
          //     breadcrumb: 'Grade Master'
          //   }
          // },
          // {
          //   path: 'grade/add',
          //   name: 'addGrade',
          //   component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterForm.vue'),
          //   meta: {
          //     title: 'routes.addGrade',
          //     requiresAuth: true,
          //     permission: 'hr.grade.create',
          //     breadcrumb: 'Add Grade'
          //   }
          // },
          // {
          //   path: 'grade/:id/edit',
          //   name: 'editGrade',
          //   component: () => import('@/modules/hr/mastertables/gradeMaster/components/GradeMasterForm.vue'),
          //   props: true,
          //   meta: {
          //     title: 'routes.editGrade',
          //     requiresAuth: true,
          //     permission: 'hr.grade.edit',
          //     breadcrumb: 'Edit Grade'
          //   }
          // },

          // Shift Pattern Master Routes
          {
            path: 'shiftpattern',
            name: 'shiftPatternMaster',
            component: () => import('@/modules/hr/mastertables/shiftPatternMaster/components/ShiftPatternMasterList.vue'),
            meta: {
              title: 'routes.shiftPatternMaster',
              requiresAuth: true,
              permission: 'hr.shiftPattern.view',
              breadcrumb: 'Shift Pattern Master'
            }
          },
          {
            path: 'shiftpattern/add',
            name: 'addShiftPattern',
            component: () => import('@/modules/hr/mastertables/shiftPatternMaster/components/ShiftPatternMasterFormNew.vue'),
            meta: {
              title: 'routes.addShiftPattern',
              requiresAuth: true,
              permission: 'hr.shiftPattern.create',
              breadcrumb: 'Add Shift Pattern'
            }
          },
          {
            path: 'shiftpattern/:id/edit',
            name: 'editShiftPattern',
            component: () => import('@/modules/hr/mastertables/shiftPatternMaster/components/ShiftPatternMasterFormNew.vue'),
            props: true,
            meta: {
              title: 'routes.editShiftPattern',
              requiresAuth: true,
              permission: 'hr.shiftPattern.edit',
              breadcrumb: 'Edit Shift Pattern'
            }
          },

          // // Leave Type Master Routes
          // {
          //   path: 'leave-type',
          //   name: 'leaveTypeMaster',
          //   component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterList.vue'),
          //   meta: {
          //     title: 'routes.leaveTypeMaster',
          //     requiresAuth: true,
          //     permission: 'hr.leaveType.view',
          //     breadcrumb: 'Leave Type Master'
          //   }
          // },
          // {
          //   path: 'leave-type/add',
          //   name: 'addLeaveType',
          //   component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterForm.vue'),
          //   meta: {
          //     title: 'routes.addLeaveType',
          //     requiresAuth: true,
          //     permission: 'hr.leaveType.create',
          //     breadcrumb: 'Add Leave Type'
          //   }
          // },
          // {
          //   path: 'leave-type/:id/edit',
          //   name: 'editLeaveType',
          //   component: () => import('@/modules/hr/mastertables/leaveTypeMaster/components/LeaveTypeMasterForm.vue'),
          //   props: true,
          //   meta: {
          //     title: 'routes.editLeaveType',
          //     requiresAuth: true,
          //     permission: 'hr.leaveType.edit',
          //     breadcrumb: 'Edit Leave Type'
          //   }
          // },

          // // Holiday Master Routes
          {
            path: 'holiday',
            name: 'holidayMaster',
            component: () => import('@/modules/hr/mastertables/holidayMaster/components/HolidayMasterList.vue'),
            meta: {
              title: 'routes.holidayMaster',
              requiresAuth: true,
              permission: 'hr.holiday.view',
              breadcrumb: 'Holiday Master'
            }
          },
          {
            path: 'holiday/add',
            name: 'addHoliday',
            component: () => import('@/modules/hr/mastertables/holidayMaster/components/HolidayMasterForm.vue'),
            meta: {
              title: 'routes.addHoliday',
              requiresAuth: true,
              permission: 'hr.holiday.create',
              breadcrumb: 'Add Holiday'
            }
          },
          {
            path: 'holiday/:Id/edit',
            name: 'editHoliday',
            component: () => import('@/modules/hr/mastertables/holidayMaster/components/HolidayMasterForm.vue'),
            props: true,
            meta: {
              title: 'routes.editHoliday',
              requiresAuth: true,
              permission: 'hr.holiday.edit',
              breadcrumb: 'Edit Holiday'
            }
          },
          // {
          //   path: 'holiday/calendar',
          //   name: 'holidayCalendar',
          //   component: () => import('@/modules/hr/mastertables/holidayMaster/components/HolidayCalendarView.vue'),
          //   meta: {
          //     title: 'routes.holidayCalendar',
          //     requiresAuth: true,
          //     permission: 'hr.holiday.view',
          //     breadcrumb: 'Holiday Calendar'
          //   }
          // },

          // Designation Document Requirement Routes
          {
            path: 'designation-documents',
            name: 'designationDocumentRequirement',
            component: () => import('@/modules/hr/mastertables/designationDocumentRequirement/components/DesignationDocumentRequirementList.vue'),
            meta: {
              title: 'routes.designationDocumentRequirement',
              requiresAuth: true,
              permission: 'hr.designationDocument.view',
              breadcrumb: 'Designation Document Requirements'
            }
          },
          {
            path: 'designation-documents/add',
            name: 'addDesignationDocumentRequirement',
            component: () => import('@/modules/hr/mastertables/designationDocumentRequirement/components/DesignationDocumentRequirementForm.vue'),
            meta: {
              title: 'routes.addDesignationDocumentRequirement',
              requiresAuth: true,
              permission: 'hr.designationDocument.create',
              breadcrumb: 'Add Document Requirement'
            }
          },
          {
            path: 'designation-documents/:id/edit',
            name: 'editDesignationDocumentRequirement',
            component: () => import('@/modules/hr/mastertables/designationDocumentRequirement/components/DesignationDocumentRequirementForm.vue'),
            props: true,
            meta: {
              title: 'routes.editDesignationDocumentRequirement',
              requiresAuth: true,
              permission: 'hr.designationDocument.edit',
              breadcrumb: 'Edit Document Requirement'
            }
          },

          // // Employee Type Master Routes
          // {
          //   path: 'employee-type',
          //   name: 'employeeTypeMaster',
          //   component: () => import('@/modules/hr/mastertables/employeeTypeMaster/components/EmployeeTypeMasterList.vue'),
          //   meta: {
          //     title: 'routes.employeeTypeMaster',
          //     requiresAuth: true,
          //     permission: 'hr.employeeType.view',
          //     breadcrumb: 'Employee Type Master'
          //   }
          // },
          // {
          //   path: 'employee-type/add',
          //   name: 'addEmployeeType',
          //   component: () => import('@/modules/hr/mastertables/employeeTypeMaster/components/EmployeeTypeMasterForm.vue'),
          //   meta: {
          //     title: 'routes.addEmployeeType',
          //     requiresAuth: true,
          //     permission: 'hr.employeeType.create',
          //     breadcrumb: 'Add Employee Type'
          //   }
          // },
          // {
          //   path: 'employee-type/:id/edit',
          //   name: 'editEmployeeType',
          //   component: () => import('@/modules/hr/mastertables/employeeTypeMaster/components/EmployeeTypeMasterForm.vue'),
          //   props: true,
          //   meta: {
          //     title: 'routes.editEmployeeType',
          //     requiresAuth: true,
          //     permission: 'hr.employeeType.edit',
          //     breadcrumb: 'Edit Employee Type'
          //   }
          // }
        ]
      },

      // Employee Management Routes
      {
        path: 'employeemanagement',
        name: 'employeeManagement',
        redirect: { name: 'employeeList' },
        meta: {
          title: 'routes.employeeManagement',
          requiresAuth: true,
          permission: 'hr.employee.view',
          breadcrumb: 'Employee Management'
        }
      },
      {
        path: 'employeemanagement/list',
        name: 'employeeList',
        component: () => import('@/modules/hr/employeeManagement/components/EmployeeMasterList.vue'),
        meta: {
          title: 'routes.employeeList',
          requiresAuth: true,
          permission: 'hr.employee.view',
          breadcrumb: 'Employee List'
        }
      },
      {
        path: 'employeemanagement/create',
        name: 'employeeCreate',
        component: () => import('@/modules/hr/employeeManagement/components/EmployeeMasterContainer.vue'),
        meta: {
          title: 'routes.employeeCreate',
          requiresAuth: true,
          permission: 'hr.employee.create',
          breadcrumb: 'Add Employee',
          mode: 'create'
        }
      },
      {
        path: 'employeemanagement/edit/:id',
        name: 'employeeEdit',
        component: () => import('@/modules/hr/employeeManagement/components/EmployeeMasterContainer.vue'),
        props: true,
        meta: {
          title: 'routes.employeeEdit',
          requiresAuth: true,
          permission: 'hr.employee.edit',
          breadcrumb: 'Edit Employee',
          mode: 'edit'
        }
      },
      {
        path: 'employeemanagement/documents',
        name: 'employeeDocuments',
        redirect: { name: 'employeeList' },
        meta: {
          title: 'routes.employeeDocuments',
          requiresAuth: true,
          permission: 'hr.employee.view',
          breadcrumb: 'Employee Documents'
        }
      },
      {
        path: 'employeemanagement/view/:id',
        name: 'employeeView',
        component: () => import('@/modules/hr/employeeManagement/components/EmployeeMasterContainer.vue'),
        props: true,
        meta: {
          title: 'routes.employeeView',
          requiresAuth: true,
          permission: 'hr.employee.view',
          breadcrumb: 'Employee Details',
          mode: 'view'
        }
      },

      // Exit Management Routes
      {
        path: 'exitmanagement',
        name: 'exitManagement',
        redirect: { name: 'exitDashboard' },
        meta: {
          title: 'routes.exitManagement',
          requiresAuth: true,
          breadcrumb: 'Exit Management'
        },
        children: [
          // Exit Dashboard
          {
            path: 'dashboard',
            name: 'exitDashboard',
            component: () => import('@/modules/hr/exitmanagement/dashboard/components/ExitDashboard.vue'),
            meta: {
              title: 'routes.exitDashboard',
              requiresAuth: true,
              permission: 'hr.exit.dashboard.view',
              breadcrumb: 'Exit Dashboard'
            }
          },
          
          // Exit Requests
          {
            path: 'requests',
            name: 'exitRequests',
            component: () => import('@/modules/hr/exitmanagement/exitRequests/components/ExitRequestsList.vue'),
            meta: {
              title: 'routes.exitRequests',
              requiresAuth: true,
              permission: 'hr.exit.requests.view',
              breadcrumb: 'Exit Requests'
            }
          },
          {
            path: 'requests/create',
            name: 'createExitRequest',
            component: () => import('@/modules/hr/exitmanagement/exitRequests/components/ExitRequestsForm.vue'),
            meta: {
              title: 'routes.createExitRequest',
              requiresAuth: true,
              permission: 'hr.exit.requests.create',
              breadcrumb: 'Create Exit Request'
            }
          },
          {
            path: 'requests/:id/view',
            name: 'viewExitRequest',
            component: () => import('@/modules/hr/exitmanagement/exitRequests/components/ExitRequestsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewExitRequest',
              requiresAuth: true,
              permission: 'hr.exit.requests.view',
              breadcrumb: 'View Exit Request'
            }
          },
          {
            path: 'requests/:id/edit',
            name: 'editExitRequest',
            component: () => import('@/modules/hr/exitmanagement/exitRequests/components/ExitRequestsForm.vue'),
            props: true,
            meta: {
              title: 'routes.editExitRequest',
              requiresAuth: true,
              permission: 'hr.exit.requests.edit',
              breadcrumb: 'Edit Exit Request'
            }
          },

          // Exit Interviews
          {
            path: 'interviews',
            name: 'exitInterviews',
            component: () => import('@/modules/hr/exitmanagement/exitInterviews/components/ExitInterviewsList.vue'),
            meta: {
              title: 'routes.exitInterviews',
              requiresAuth: true,
              permission: 'hr.exit.interviews.view',
              breadcrumb: 'Exit Interviews'
            }
          },
          {
            path: 'interviews/schedule',
            name: 'scheduleExitInterview',
            component: () => import('@/modules/hr/exitmanagement/exitInterviews/components/ExitInterviewsSchedule.vue'),
            meta: {
              title: 'routes.scheduleExitInterview',
              requiresAuth: true,
              permission: 'hr.exit.interviews.schedule',
              breadcrumb: 'Schedule Exit Interview'
            }
          },
          {
            path: 'interviews/:id/conduct',
            name: 'conductExitInterview',
            component: () => import('@/modules/hr/exitmanagement/exitInterviews/components/ExitInterviewsConduct.vue'),
            props: true,
            meta: {
              title: 'routes.conductExitInterview',
              requiresAuth: true,
              permission: 'hr.exit.interviews.conduct',
              breadcrumb: 'Conduct Exit Interview'
            }
          },
          {
            path: 'interviews/:id/view',
            name: 'viewExitInterview',
            component: () => import('@/modules/hr/exitmanagement/exitInterviews/components/ExitInterviewsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewExitInterview',
              requiresAuth: true,
              permission: 'hr.exit.interviews.view',
              breadcrumb: 'View Exit Interview'
            }
          },

          // Exit Tasks
          {
            path: 'tasks',
            name: 'exitTasks',
            component: () => import('@/modules/hr/exitmanagement/exitTasks/components/ExitTasksList.vue'),
            meta: {
              title: 'routes.exitTasks',
              requiresAuth: true,
              permission: 'hr.exit.tasks.view',
              breadcrumb: 'Exit Tasks'
            }
          },
          {
            path: 'tasks/create',
            name: 'createExitTask',
            component: () => import('@/modules/hr/exitmanagement/exitTasks/components/ExitTasksForm.vue'),
            meta: {
              title: 'routes.createExitTask',
              requiresAuth: true,
              permission: 'hr.exit.tasks.create',
              breadcrumb: 'Create Exit Task'
            }
          },
          {
            path: 'tasks/:id/edit',
            name: 'editExitTask',
            component: () => import('@/modules/hr/exitmanagement/exitTasks/components/ExitTasksForm.vue'),
            props: true,
            meta: {
              title: 'routes.editExitTask',
              requiresAuth: true,
              permission: 'hr.exit.tasks.edit',
              breadcrumb: 'Edit Exit Task'
            }
          },
          {
            path: 'tasks/:id/view',
            name: 'viewExitTask',
            component: () => import('@/modules/hr/exitmanagement/exitTasks/components/ExitTasksView.vue'),
            props: true,
            meta: {
              title: 'routes.viewExitTask',
              requiresAuth: true,
              permission: 'hr.exit.tasks.view',
              breadcrumb: 'View Exit Task'
            }
          },
          {
            path: 'tasks/:id/complete',
            name: 'completeExitTask',
            component: () => import('@/modules/hr/exitmanagement/exitTasks/components/ExitTasksComplete.vue'),
            props: true,
            meta: {
              title: 'routes.completeExitTask',
              requiresAuth: true,
              permission: 'hr.exit.tasks.complete',
              breadcrumb: 'Complete Exit Task'
            }
          },

          // Exit Documents
          {
            path: 'documents',
            name: 'exitDocuments',
            component: () => import('@/modules/hr/exitmanagement/exitDocuments/components/ExitDocumentsList.vue'),
            meta: {
              title: 'routes.exitDocuments',
              requiresAuth: true,
              permission: 'hr.exit.documents.view',
              breadcrumb: 'Exit Documents'
            }
          },
          {
            path: 'documents/upload',
            name: 'uploadExitDocuments',
            component: () => import('@/modules/hr/exitmanagement/exitDocuments/components/ExitDocumentsUpload.vue'),
            meta: {
              title: 'routes.uploadExitDocuments',
              requiresAuth: true,
              permission: 'hr.exit.documents.upload',
              breadcrumb: 'Upload Exit Documents'
            }
          },

          // Knowledge Transfer
          {
            path: 'knowledge-transfer',
            name: 'knowledgeTransfer',
            component: () => import('@/modules/hr/exitmanagement/knowledgeTransfer/components/KnowledgeTransferList.vue'),
            meta: {
              title: 'routes.knowledgeTransfer',
              requiresAuth: true,
              permission: 'hr.exit.knowledge.view',
              breadcrumb: 'Knowledge Transfer'
            }
          },
          {
            path: 'knowledge-transfer/dashboard',
            name: 'knowledgeTransferDashboard',
            component: () => import('@/modules/hr/exitmanagement/knowledgeTransfer/components/KnowledgeTransferDashboard.vue'),
            meta: {
              title: 'routes.knowledgeTransferDashboard',
              requiresAuth: true,
              permission: 'hr.exit.knowledge.view',
              breadcrumb: 'Knowledge Transfer Dashboard'
            }
          },
   {
            path: 'knowledge-transfer/create',
            name: 'knowledgeTransferCreate',
            component: () => import('@/modules/hr/exitmanagement/knowledgeTransfer/components/KnowledgeTransferForm.vue'),
            meta: {
              title: 'routes.knowledgeTransfercreate',
              requiresAuth: true,
              permission: 'hr.exit.knowledge.create',
              breadcrumb: 'Knowledge Transfer create'
            }
          },
          // Financial Settlements
          {
            path: 'settlements',
            name: 'financialSettlements',
            component: () => import('@/modules/hr/exitmanagement/financialSettlements/components/FinancialSettlementsList.vue'),
            meta: {
              title: 'routes.financialSettlements',
              requiresAuth: true,
              permission: 'hr.exit.settlements.view',
              breadcrumb: 'Financial Settlements'
            }
          },
          {
            path: 'financial-settlements/create',
            name: 'createFinancialSettlement',
            component: () => import('@/modules/hr/exitmanagement/financialSettlements/components/FinancialSettlementsForm.vue'),
            meta: {
              title: 'routes.createFinancialSettlement',
              requiresAuth: true,
              permission: 'hr.exit.settlements.create',
              breadcrumb: 'Create Financial Settlement'
            }
          },
          {
            path: 'financial-settlements/:id/edit',
            name: 'editFinancialSettlement',
            component: () => import('@/modules/hr/exitmanagement/financialSettlements/components/FinancialSettlementsForm.vue'),
            props: true,
            meta: {
              title: 'routes.editFinancialSettlement',
              requiresAuth: true,
              permission: 'hr.exit.settlements.edit',
              breadcrumb: 'Edit Financial Settlement'
            }
          },
          {
            path: 'financial-settlements/:id/view',
            name: 'viewFinancialSettlement',
            component: () => import('@/modules/hr/exitmanagement/financialSettlements/components/FinancialSettlementsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewFinancialSettlement',
              requiresAuth: true,
              permission: 'hr.exit.settlements.view',
              breadcrumb: 'View Financial Settlement'
            }
          }
        ]
      },

      // Leave Management Routes
     {
        path: 'leavemanagement',
        name: 'leaveManagement',
        redirect: { name: 'leaveApplications' },
        meta: {
          title: 'routes.leaveManagement',
          requiresAuth: true,
          breadcrumb: 'Leave Management',
        },
        children: [
          // Leave Applications
          {
            path: 'applications',
            name: 'leaveApplications',
            component: () =>
              import(
                '@/modules/hr/leavemanagement/leaveApplications/components/LeaveApplicationList.vue'
              ),
            meta: {
              title: 'routes.leaveApplications',
              requiresAuth: true,
              permission: 'hr.leave.applications.view',
              breadcrumb: 'Leave Applications',
            },
          },
          {
            path: 'applications/apply',
            name: 'applyLeave',
            component: () =>
              import(
                '@/modules/hr/leavemanagement/leaveApplications/components/LeaveApplicationForm.vue'
              ),
            meta: {
              title: 'routes.applyLeave',
              requiresAuth: true,
              permission: 'hr.leave.applications.create',
              breadcrumb: 'Apply Leave',
            },
          },
          {
            path: 'applications/:id/view',
            name: 'viewLeaveApplication',
            component: () =>
              import(
                '@/modules/hr/leavemanagement/leaveApplications/components/LeaveApplicationView.vue'
              ),
            props: true,
            meta: {
              title: 'routes.viewLeaveApplication',
              requiresAuth: true,
              permission: 'hr.leave.applications.view',
              breadcrumb: 'View Leave Application',
            },
          },
          {
            path: 'applications/:id/edit',
            name: 'editLeaveApplication',
            component: () =>
              import(
                '@/modules/hr/leavemanagement/leaveApplications/components/LeaveApplicationForm.vue'
              ),
            props: true,
            meta: {
              title: 'routes.editLeaveApplication',
              requiresAuth: true,
              permission: 'hr.leave.applications.edit',
              breadcrumb: 'Edit Leave Application',
            },
          },
          {
            path: 'balance',
            name: 'balance',
            component: () => import('@/modules/hr/leavemanagement/leaveBalance/components/LeaveBalanceList.vue'),
            meta: {
              title: 'routes.leaveBalance',
              requiresAuth: true,
              permission: 'hr.leave.view',
              breadcrumb: 'Leave Balance',
            },
          },
          {
            path: 'leave-balance/create',
            name: 'leave-balance/create',
            component: () => import('@/modules/hr/leavemanagement/leaveBalance/components/LeaveBalanceForm.vue'),
            meta: {
              title: 'routes.leaveBalance',
              requiresAuth: true,
              permission: 'hr.leave.view',
              breadcrumb: 'Leave Balance',
            },
          }
        ],
      },

      // Onboarding Management Routes
      {
        path: 'onboardingmanagement',
        name: 'onboardingManagement',
        redirect: { name: 'onboardingDashboard' },
        meta: {
          title: 'routes.onboardingManagement',
          requiresAuth: true,
          breadcrumb: 'Onboarding Management'
        },
        children: [
          // Onboarding Dashboard
          {
            path: 'dashboard',
            name: 'onboardingDashboard',
            component: () => import('@/modules/hr/onboardingmanagement/dashboard/components/OnboardingDashboard.vue'),
            meta: {
              title: 'routes.onboardingDashboard',
              requiresAuth: true,
              permission: 'hr.onboarding.dashboard.view',
              breadcrumb: 'Onboarding Dashboard'
            }
          },

          // Onboarding Instances
          {
            path: 'instances',
            name: 'onboardingInstances',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesList.vue'),
            meta: {
              title: 'routes.onboardingInstances',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.view',
              breadcrumb: 'Onboarding Instances'
            }
          },
          {
            path: 'instances/create',
            name: 'createOnboardingInstance',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesForm.vue'),
            meta: {
              title: 'routes.createOnboardingInstance',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.create',
              breadcrumb: 'Create Onboarding Instance'
            }
          },
          {
            path: 'instances/:id/view',
            name: 'viewOnboardingInstance',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingInstance',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.view',
              breadcrumb: 'View Onboarding Instance'
            }
          },
          {
            path: 'instances/:id/progress',
            name: 'onboardingInstanceProgress',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesProgress.vue'),
            props: true,
            meta: {
              title: 'routes.onboardingInstanceProgress',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.view',
              breadcrumb: 'Onboarding Progress'
            }
          },

          // Onboarding Tasks
          {
            path: 'tasks',
            name: 'onboardingTasks',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksList.vue'),
            meta: {
              title: 'routes.onboardingTasks',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.view',
              breadcrumb: 'Onboarding Tasks'
            }
          },
          {
            path: 'tasks/kanban',
            name: 'onboardingTasksKanban',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksKanban.vue'),
            meta: {
              title: 'routes.onboardingTasksKanban',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.view',
              breadcrumb: 'Tasks Kanban Board'
            }
          },
          {
            path: 'tasks/calendar',
            name: 'onboardingTasksCalendar',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksCalendar.vue'),
            meta: {
              title: 'routes.onboardingTasksCalendar',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.view',
              breadcrumb: 'Tasks Calendar'
            }
          },

          // Onboarding Tasks - Additional Routes
          {
            path: 'tasks/create',
            name: 'createOnboardingTask',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksForm.vue'),
            meta: {
              title: 'routes.createOnboardingTask',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.create',
              breadcrumb: 'Create Onboarding Task'
            }
          },
          {
            path: 'tasks/:id/edit',
            name: 'editOnboardingTask',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingTask',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.edit',
              breadcrumb: 'Edit Onboarding Task'
            }
          },
          {
            path: 'tasks/:id/view',
            name: 'viewOnboardingTask',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingTask',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.view',
              breadcrumb: 'View Onboarding Task'
            }
          },
          {
            path: 'tasks/bulk-actions',
            name: 'onboardingTasksBulkActions',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingTasks/components/OnboardingTasksBulkActions.vue'),
            meta: {
              title: 'routes.onboardingTasksBulkActions',
              requiresAuth: true,
              permission: 'hr.onboarding.tasks.bulk',
              breadcrumb: 'Bulk Task Actions'
            }
          },

          // Onboarding Documents
          {
            path: 'documents',
            name: 'onboardingDocuments',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsList.vue'),
            meta: {
              title: 'routes.onboardingDocuments',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.view',
              breadcrumb: 'Onboarding Documents'
            }
          },
          {
            path: 'documents/create',
            name: 'createOnboardingDocument',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsForm.vue'),
            meta: {
              title: 'routes.createOnboardingDocument',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.create',
              breadcrumb: 'Create Document'
            }
          },
          {
            path: 'documents/:id/edit',
            name: 'editOnboardingDocument',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingDocument',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.edit',
              breadcrumb: 'Edit Document'
            }
          },
          {
            path: 'documents/:id/view',
            name: 'viewOnboardingDocument',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingDocument',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.view',
              breadcrumb: 'View Document'
            }
          },
          {
            path: 'documents/upload',
            name: 'uploadOnboardingDocuments',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsUpload.vue'),
            meta: {
              title: 'routes.uploadOnboardingDocuments',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.upload',
              breadcrumb: 'Upload Documents'
            }
          },
          {
            path: 'documents/:id/approve',
            name: 'approveOnboardingDocument',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsApproval.vue'),
            props: true,
            meta: {
              title: 'routes.approveOnboardingDocument',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.approve',
              breadcrumb: 'Approve Document'
            }
          },
          {
            path: 'documents/:id/validate',
            name: 'validateOnboardingDocument',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingDocuments/components/OnboardingDocumentsValidation.vue'),
            props: true,
            meta: {
              title: 'routes.validateOnboardingDocument',
              requiresAuth: true,
              permission: 'hr.onboarding.documents.validate',
              breadcrumb: 'Validate Document'
            }
          },

          // Onboarding Milestones
          {
            path: 'milestones',
            name: 'onboardingMilestones',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesList.vue'),
            meta: {
              title: 'routes.onboardingMilestones',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.view',
              breadcrumb: 'Onboarding Milestones'
            }
          },
          {
            path: 'milestones/create',
            name: 'createOnboardingMilestone',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesForm.vue'),
            meta: {
              title: 'routes.createOnboardingMilestone',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.create',
              breadcrumb: 'Create Milestone'
            }
          },
          {
            path: 'milestones/:id/edit',
            name: 'editOnboardingMilestone',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingMilestone',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.edit',
              breadcrumb: 'Edit Milestone'
            }
          },
          {
            path: 'milestones/:id/view',
            name: 'viewOnboardingMilestone',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingMilestone',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.view',
              breadcrumb: 'View Milestone'
            }
          },
          {
            path: 'milestones/progress',
            name: 'onboardingMilestonesProgress',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesProgress.vue'),
            meta: {
              title: 'routes.onboardingMilestonesProgress',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.view',
              breadcrumb: 'Milestones Progress'
            }
          },
          {
            path: 'milestones/timeline',
            name: 'onboardingMilestonesTimeline',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingMilestones/components/OnboardingMilestonesTimeline.vue'),
            meta: {
              title: 'routes.onboardingMilestonesTimeline',
              requiresAuth: true,
              permission: 'hr.onboarding.milestones.view',
              breadcrumb: 'Milestones Timeline'
            }
          },

          // Onboarding Feedback
          {
            path: 'feedback',
            name: 'onboardingFeedback',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackList.vue'),
            meta: {
              title: 'routes.onboardingFeedback',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.view',
              breadcrumb: 'Onboarding Feedback'
            }
          },
          {
            path: 'feedback/create',
            name: 'createOnboardingFeedback',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackForm.vue'),
            meta: {
              title: 'routes.createOnboardingFeedback',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.create',
              breadcrumb: 'Create Feedback'
            }
          },
          {
            path: 'feedback/:id/edit',
            name: 'editOnboardingFeedback',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingFeedback',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.edit',
              breadcrumb: 'Edit Feedback'
            }
          },
          {
            path: 'feedback/:id/view',
            name: 'viewOnboardingFeedback',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingFeedback',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.view',
              breadcrumb: 'View Feedback'
            }
          },
          {
            path: 'feedback/:id/respond',
            name: 'respondOnboardingFeedback',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackResponse.vue'),
            props: true,
            meta: {
              title: 'routes.respondOnboardingFeedback',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.respond',
              breadcrumb: 'Respond to Feedback'
            }
          },
          {
            path: 'feedback/analytics',
            name: 'onboardingFeedbackAnalytics',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingFeedback/components/OnboardingFeedbackAnalytics.vue'),
            meta: {
              title: 'routes.onboardingFeedbackAnalytics',
              requiresAuth: true,
              permission: 'hr.onboarding.feedback.view',
              breadcrumb: 'Feedback Analytics'
            }
          },

          // Onboarding Programs
          {
            path: 'programs',
            name: 'onboardingPrograms',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingPrograms/components/OnboardingProgramsList.vue'),
            meta: {
              title: 'routes.onboardingPrograms',
              requiresAuth: true,
              permission: 'hr.onboarding.programs.view',
              breadcrumb: 'Onboarding Programs'
            }
          },
          {
            path: 'programs/create',
            name: 'createOnboardingProgram',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingPrograms/components/OnboardingProgramsForm.vue'),
            meta: {
              title: 'routes.createOnboardingProgram',
              requiresAuth: true,
              permission: 'hr.onboarding.programs.create',
              breadcrumb: 'Create Onboarding Program'
            }
          },
          {
            path: 'programs/:id/edit',
            name: 'editOnboardingProgram',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingPrograms/components/OnboardingProgramsForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingProgram',
              requiresAuth: true,
              permission: 'hr.onboarding.programs.edit',
              breadcrumb: 'Edit Onboarding Program'
            }
          },
          {
            path: 'programs/:id/view',
            name: 'viewOnboardingProgram',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingPrograms/components/OnboardingProgramsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewOnboardingProgram',
              requiresAuth: true,
              permission: 'hr.onboarding.programs.view',
              breadcrumb: 'View Onboarding Program'
            }
          },

          // Additional Onboarding Instances Routes
          {
            path: 'instances/:id/edit',
            name: 'editOnboardingInstance',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesForm.vue'),
            props: true,
            meta: {
              title: 'routes.editOnboardingInstance',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.edit',
              breadcrumb: 'Edit Onboarding Instance'
            }
          },
          {
            path: 'instances/dashboard',
            name: 'onboardingInstancesDashboard',
            component: () => import('@/modules/hr/onboardingmanagement/onboardingInstances/components/OnboardingInstancesDashboard.vue'),
            meta: {
              title: 'routes.onboardingInstancesDashboard',
              requiresAuth: true,
              permission: 'hr.onboarding.instances.view',
              breadcrumb: 'Instances Dashboard'
            }
          }
        ]
      },

      // // Attendance Management Routes
      // {
      //   path: 'attendance',
      //   name: 'attendanceManagement',
      //   component: () => import('@/modules/hr/attendance/components/AttendanceList.vue'),
      //   meta: {
      //     title: 'routes.attendanceManagement',
      //     requiresAuth: true,
      //     permission: 'hr.attendance.view',
      //     breadcrumb: 'Attendance Management'
      //   }
      // },
      // {
      //   path: 'attendance/daily',
      //   name: 'dailyAttendance',
      //   component: () => import('@/modules/hr/attendance/components/DailyAttendance.vue'),
      //   meta: {
      //     title: 'routes.dailyAttendance',
      //     requiresAuth: true,
      //     permission: 'hr.attendance.view',
      //     breadcrumb: 'Daily Attendance'
      //   }
      // },
      // {
      //   path: 'attendance/monthly',
      //   name: 'monthlyAttendance',
      //   component: () => import('@/modules/hr/attendance/components/MonthlyAttendance.vue'),
      //   meta: {
      //     title: 'routes.monthlyAttendance',
      //     requiresAuth: true,
      //     permission: 'hr.attendance.view',
      //     breadcrumb: 'Monthly Attendance'
      //   }
      // },

      // // Leave Management Routes
      // {
      //   path: 'leave',
      //   name: 'leaveManagement',
      //   component: () => import('@/modules/hr/leave/components/LeaveList.vue'),
      //   meta: {
      //     title: 'routes.leaveManagement',
      //     requiresAuth: true,
      //     permission: 'hr.leave.view',
      //     breadcrumb: 'Leave Management'
      //   }
      // },
      // {
      //   path: 'leave/apply',
      //   name: 'applyLeave',
      //   component: () => import('@/modules/hr/leave/components/LeaveApplication.vue'),
      //   meta: {
      //     title: 'routes.applyLeave',
      //     requiresAuth: true,
      //     permission: 'hr.leave.apply',
      //     breadcrumb: 'Apply Leave'
      //   }
      // },
      // {
      //   path: 'leave/approval',
      //   name: 'leaveApproval',
      //   component: () => import('@/modules/hr/leave/components/LeaveApproval.vue'),
      //   meta: {
      //     title: 'routes.leaveApproval',
      //     requiresAuth: true,
      //     permission: 'hr.leave.approve',
      //     breadcrumb: 'Leave Approval'
      //   }
      // },
      // {
      //   path: 'leave/balance',
      //   name: 'leaveBalance',
      //   component: () => import('@/modules/hr/leave/components/LeaveBalance.vue'),
      //   meta: {
      //     title: 'routes.leaveBalance',
      //     requiresAuth: true,
      //     permission: 'hr.leave.view',
      //     breadcrumb: 'Leave Balance'
      //   }
      // },

      // // Payroll Management Routes
      // {
      //   path: 'payroll',
      //   name: 'payrollManagement',
      //   component: () => import('@/modules/hr/payroll/components/PayrollList.vue'),
      //   meta: {
      //     title: 'routes.payrollManagement',
      //     requiresAuth: true,
      //     permission: 'hr.payroll.view',
      //     breadcrumb: 'Payroll Management'
      //   }
      // },
      // {
      //   path: 'payroll/process',
      //   name: 'payrollProcess',
      //   component: () => import('@/modules/hr/payroll/components/PayrollProcess.vue'),
      //   meta: {
      //     title: 'routes.payrollProcess',
      //     requiresAuth: true,
      //     permission: 'hr.payroll.process',
      //     breadcrumb: 'Payroll Process'
      //   }
      // },
      // {
      //   path: 'payroll/salary-structure',
      //   name: 'salaryStructure',
      //   component: () => import('@/modules/hr/payroll/components/SalaryStructure.vue'),
      //   meta: {
      //     title: 'routes.salaryStructure',
      //     requiresAuth: true,
      //     permission: 'hr.payroll.view',
      //     breadcrumb: 'Salary Structure'
      //   }
      // },

      // // Reports Routes
      // {
      //   path: 'reports',
      //   name: 'hrReports',
      //   component: () => import('@/modules/hr/reports/components/HRReports.vue'),
      //   meta: {
      //     title: 'routes.hrReports',
      //     requiresAuth: true,
      //     permission: 'hr.reports.view',
      //     breadcrumb: 'HR Reports'
      //   },
      //   children: [
      //     {
      //       path: 'employee-report',
      //       name: 'employeeReport',
      //       component: () => import('@/modules/hr/reports/components/EmployeeReport.vue'),
      //       meta: {
      //         title: 'Employee Report',
      //         requiresAuth: true,
      //         permission: 'hr.reports.employee',
      //         breadcrumb: 'Employee Report'
      //       }
      //     },
      //     {
      //       path: 'attendance-report',
      //       name: 'attendanceReport',
      //       component: () => import('@/modules/hr/reports/components/AttendanceReport.vue'),
      //       meta: {
      //         title: 'Attendance Report',
      //         requiresAuth: true,
      //         permission: 'hr.reports.attendance',
      //         breadcrumb: 'Attendance Report'
      //       }
      //     },
      //     {
      //       path: 'leave-report',
      //       name: 'leaveReport',
      //       component: () => import('@/modules/hr/reports/components/LeaveReport.vue'),
      //       meta: {
      //         title: 'Leave Report',
      //         requiresAuth: true,
      //         permission: 'hr.reports.leave',
      //         breadcrumb: 'Leave Report'
      //       }
      //     },
      //     {
      //       path: 'payroll-report',
      //       name: 'payrollReport',
      //       component: () => import('@/modules/hr/reports/components/PayrollReport.vue'),
      //       meta: {
      //         title: 'Payroll Report',
      //         requiresAuth: true,
      //         permission: 'hr.reports.payroll',
      //         breadcrumb: 'Payroll Report'
      //       }
      //     }
      //   ]
      // },

      // Attendance Management Routes
      {
        path: 'attendancemanagement',
        name: 'attendanceManagement',
        redirect: { name: 'attendanceDashboard' },
        meta: {
          title: 'routes.attendanceManagement',
          requiresAuth: true,
          breadcrumb: 'Attendance Management'
        },
        children: [
          // Attendance Dashboard
          {
            path: 'dashboard',
            name: 'attendanceDashboard',
            component: () => import('@/modules/hr/attendancemanagement/dashboard/components/AttendanceDashboard.vue'),
            meta: {
              title: 'routes.attendanceDashboard',
              requiresAuth: true,
              permission: 'hr.attendance.dashboard.view',
              breadcrumb: 'Attendance Dashboard'
            }
          },

          {
            path: 'dailyattendance',
            name: 'dailyattendance',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/DailyAttendanceTable.vue'),
            meta: {
              title: 'routes.dailyattendance',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance master'
            }
          },
          // Attendance Master - Monthly View with Vertical/Horizontal Tabs
          {
            path: 'master',
            name: 'attendanceMaster',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/AttendanceMonthlyView.vue'),
            meta: {
              title: 'routes.attendanceMaster',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance Master'
            }
          },
          // Attendance Master List (legacy)
          {
            path: 'master/list',
            name: 'attendanceMasterList',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/AttendanceMasterList.vue'),
            meta: {
              title: 'routes.attendanceMasterList',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance List'
            }
          },
          {
            path: 'master/dashboard',
            name: 'attendanceMasterDashboard',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/AttendanceMasterDashboard.vue'),
            meta: {
              title: 'routes.attendanceMasterDashboard',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance Master Dashboard'
            }
          },
          {
            path: 'master/calendar',
            name: 'attendanceMasterCalendar',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/AttendanceMasterCalendar.vue'),
            meta: {
              title: 'routes.attendanceMasterCalendar',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance Calendar'
            }
          },
          {
            path: 'master/insights',
            name: 'attendanceMasterInsights',
            component: () => import('@/modules/hr/attendancemanagement/attendanceMaster/components/AttendanceMasterInsights.vue'),
            meta: {
              title: 'routes.attendanceMasterInsights',
              requiresAuth: true,
              permission: 'hr.attendance.master.view',
              breadcrumb: 'Attendance Insights'
            }
          },

          // Time Entry Management
          {
            path: 'timeentry',
            name: 'timeEntryManagement',
            component: () => import('@/modules/hr/attendancemanagement/timeEntryManagement/components/TimeEntryList.vue'),
            meta: {
              title: 'routes.timeEntryManagement',
              requiresAuth: true,
              permission: 'hr.attendance.timeentry.view',
              breadcrumb: 'Time Entry Management'
            }
          },
          {
            path: 'timeentry/clock',
            name: 'timeEntryClock',
            component: () => import('@/modules/hr/attendancemanagement/timeEntryManagement/components/TimeEntryClock.vue'),
            meta: {
              title: 'routes.timeEntryClock',
              requiresAuth: true,
              permission: 'hr.attendance.timeentry.clock',
              breadcrumb: 'Time Clock'
            }
          },

          // Overtime Management
          {
            path: 'overtime',
            name: 'overtimeManagement',
            component: () => import('@/modules/hr/attendancemanagement/overtimeManagement/components/OvertimeTrackingList.vue'),
            meta: {
              title: 'routes.overtimeManagement',
              requiresAuth: true,
              permission: 'hr.attendance.overtime.view',
              breadcrumb: 'Overtime Management'
            }
          },
          {
            path: 'overtime/analytics',
            name: 'overtimeAnalytics',
            component: () => import('@/modules/hr/attendancemanagement/overtimeManagement/components/OvertimeAnalytics.vue'),
            meta: {
              title: 'routes.overtimeAnalytics',
              requiresAuth: true,
              permission: 'hr.attendance.overtime.view',
              breadcrumb: 'Overtime Analytics'
            }
          },

          // Exception Management & Regularization
          {
            path: 'exceptions',
            name: 'attendanceExceptions',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/views/AttendanceExceptionManagement.vue'),
            meta: {
              title: 'routes.attendanceExceptions',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.view',
              breadcrumb: 'Attendance Exceptions & Regularization'
            }
          },
          {
            path: 'exceptions/new',
            name: 'CreateAttendanceException',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/components/AttendanceExceptionForm.vue'),
            props: { mode: 'create' },
            meta: {
              title: 'routes.createException',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.create',
              breadcrumb: 'Create Exception'
            }
          },
          {
            path: 'exceptions/:id/edit',
            name: 'EditAttendanceException',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/components/AttendanceExceptionForm.vue'),
            props: (route: any) => ({
              exceptionId: parseInt(route.params.id as string),
              mode: 'edit'
            }),
            meta: {
              title: 'routes.editException',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.edit',
              breadcrumb: 'Edit Exception'
            }
          },
          {
            path: 'exceptions/:id/view',
            name: 'AttendanceExceptionView',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/components/AttendanceExceptionView.vue'),
            props: (route: any) => ({
              exceptionId: parseInt(route.params.id as string)
            }),
            meta: {
              title: 'routes.viewException',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.view',
              breadcrumb: 'View Exception'
            }
          },
          {
            path: 'exceptions/:id/resolve',
            name: 'ResolveAttendanceException',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/components/AttendanceExceptionForm.vue'),
            props: (route: any) => ({
              exceptionId: parseInt(route.params.id as string),
              mode: 'resolve'
            }),
            meta: {
              title: 'routes.resolveException',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.resolve',
              breadcrumb: 'Resolve Exception'
            }
          },
          {
            path: 'exceptions/analytics',
            name: 'ExceptionAnalytics',
            component: () => import('@/modules/hr/attendancemanagement/exceptionManagement/components/ExceptionAnalytics.vue'),
            meta: {
              title: 'routes.exceptionAnalytics',
              requiresAuth: true,
              permission: 'hr.attendance.exceptions.view',
              breadcrumb: 'Exception Analytics'
            }
          },
          // Attendance Regularization - List
          {
            path: 'regularization',
            name: 'AttendanceRegularizationList',
            component: () => import('@/modules/hr/attendancemanagement/regularizationManagement/components/AttendanceRegularizationList.vue'),
            meta: {
              title: 'routes.attendanceRegularization',
              requiresAuth: true,
              permission: 'hr.attendance.regularization.view',
              breadcrumb: 'Attendance Regularization'
            }
          },
          {
            path: 'regularization/new',
            name: 'NewAttendanceRegularization',
            component: () => import('@/modules/hr/attendancemanagement/regularizationManagement/components/AttendanceRegularizationForm.vue'),
            meta: {
              title: 'routes.newRegularization',
              requiresAuth: true,
              permission: 'hr.attendance.regularization.create',
              breadcrumb: 'New Regularization Request'
            }
          },
          {
            path: 'regularization/:id/edit',
            name: 'EditAttendanceRegularization',
            component: () => import('@/modules/hr/attendancemanagement/regularizationManagement/components/AttendanceRegularizationForm.vue'),
            props: (route: any) => ({
              regularizationId: parseInt(route.params.id as string),
              mode: 'edit'
            }),
            meta: {
              title: 'routes.editRegularization',
              requiresAuth: true,
              permission: 'hr.attendance.regularization.edit',
              breadcrumb: 'Edit Regularization Request'
            }
          },
          {
            path: 'regularization/:id/view',
            name: 'AttendanceRegularizationView',
            component: () => import('@/modules/hr/attendancemanagement/regularizationManagement/components/AttendanceRegularizationView.vue'),
            props: (route: any) => ({
              regularizationId: parseInt(route.params.id as string)
            }),
            meta: {
              title: 'routes.viewRegularization',
              requiresAuth: true,
              permission: 'hr.attendance.regularization.view',
              breadcrumb: 'View Regularization Request'
            }
          },
          {
            path: 'regularization/analytics',
            name: 'RegularizationAnalytics',
            component: () => import('@/modules/hr/attendancemanagement/regularizationManagement/components/RegularizationAnalytics.vue'),
            meta: {
              title: 'routes.regularizationAnalytics',
              requiresAuth: true,
              permission: 'hr.attendance.regularization.view',
              breadcrumb: 'Regularization Analytics'
            }
          },

          // Shift Handover
          {
            path: 'shift-handover',
            name: 'shiftHandover',
            component: () => import('@/modules/hr/attendancemanagement/shiftHandover/components/ShiftHandoverList.vue'),
            meta: {
              title: 'routes.shiftHandover',
              requiresAuth: true,
              permission: 'hr.attendance.handover.view',
              breadcrumb: 'Shift Handover'
            }
          },

          // Analytics & Reporting
          {
            path: 'analytics',
            name: 'attendanceAnalytics',
            component: () => import('@/modules/hr/attendancemanagement/analyticsReporting/components/AttendanceAnalyticsDashboard.vue'),
            meta: {
              title: 'routes.attendanceAnalytics',
              requiresAuth: true,
              permission: 'hr.attendance.analytics.view',
              breadcrumb: 'Attendance Analytics'
            }
          }
        ]
      },

      // Shift Management Routes
      {
        path: 'shift-management',
        name: 'shiftManagement',
        redirect: { name: 'shiftScheduleList' },
        meta: {
          title: 'routes.shiftManagement',
          requiresAuth: true,
          breadcrumb: 'Shift Management'
        },
        children: [
          {
            path: 'schedule',
            name: 'shiftScheduleList',
            component: () => import('@/modules/hr/shift-management/components/ShiftScheduleList.vue'),
            meta: {
              title: 'routes.shiftScheduleList',
              requiresAuth: true,
              permission: 'hr.shift.schedule.view',
              breadcrumb: 'Shift Schedule'
            }
          },
          {
            path: 'schedule/add',
            name: 'shiftScheduleAdd',
            component: () => import('@/modules/hr/shift-management/components/ShiftScheduleForm.vue'),
            meta: {
              title: 'routes.shiftScheduleAdd',
              requiresAuth: true,
              permission: 'hr.shift.schedule.create',
              breadcrumb: 'Add Shift Schedule'
            }
          },
          {
            path: 'schedule/bulk-assign',
            name: 'shiftScheduleBulkAssign',
            component: () => import('@/modules/hr/shift-management/components/ShiftScheduleBulkAssign.vue'),
            meta: {
              title: 'routes.shiftScheduleBulkAssign',
              requiresAuth: true,
              permission: 'hr.shift.schedule.create',
              breadcrumb: 'Bulk Assign Schedules'
            }
          },
          {
            path: 'schedule/:id/view',
            name: 'shiftScheduleView',
            component: () => import('@/modules/hr/shift-management/components/ShiftScheduleView.vue'),
            meta: {
              title: 'routes.shiftScheduleView',
              requiresAuth: true,
              permission: 'hr.shift.schedule.view',
              breadcrumb: 'View Shift Schedule'
            }
          },
          {
            path: 'schedule/:id/edit',
            name: 'shiftScheduleEdit',
            component: () => import('@/modules/hr/shift-management/components/ShiftScheduleForm.vue'),
            meta: {
              title: 'routes.shiftScheduleEdit',
              requiresAuth: true,
              permission: 'hr.shift.schedule.update',
              breadcrumb: 'Edit Shift Schedule'
            }
          },
          {
            path: 'calendar',
            name: 'shiftScheduleCalendar',
            component: () => import('@/modules/hr/shift-management/components/ScheduleCalendar.vue'),
            meta: {
              title: 'routes.shiftScheduleCalendar',
              requiresAuth: true,
              permission: 'hr.shift.schedule.view',
              breadcrumb: 'Schedule Calendar'
            }
          },
          {
            path: 'swap-requests',
            name: 'shiftSwapRequests',
            component: () => import('@/modules/hr/shift-management/components/ShiftSwapRequest.vue'),
            meta: {
              title: 'routes.shiftSwapRequests',
              requiresAuth: true,
              permission: 'hr.shift.swap.view',
              breadcrumb: 'Shift Swap Requests'
            }
          }
        ]
      },

      // Shift Routes (for backwards compatibility with menu system)
      {
        path: 'shift',
        name: 'shift',
        meta: {
          title: 'routes.shift',
          requiresAuth: true,
          breadcrumb: 'Shift'
        },
        children: [
          {
            path: 'notifications',
            name: 'shiftNotifications',
            component: () => import('@/modules/hr/shift-management/components/ShiftNotification.vue'),
            meta: {
              title: 'routes.shiftNotifications',
              requiresAuth: true,
              permission: 'hr.shift.notification.view',
              breadcrumb: 'Shift Notifications'
            }
          }
        ]
      },

      // Payroll Management Routes
      {
        path: 'payrollmanagement',
        name: 'payrollManagement',
        redirect: { name: 'payrollMasterList' },
        meta: {
          title: 'routes.payrollManagement',
          requiresAuth: true,
          breadcrumb: 'Payroll Management'
        },
        children: [
          // Payroll Master Routes
          {
            path: 'master',
            name: 'payrollMasterList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-master/PayrollMasterList.vue'),
            meta: {
              title: 'routes.payrollMasterList',
              requiresAuth: true,
              permission: 'hr.payroll.master.view',
              breadcrumb: 'Payroll Master'
            }
          },
          {
            path: 'master/create',
            name: 'payrollMasterCreate',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-master/PayrollMasterCreate.vue'),
            meta: {
              title: 'routes.payrollMasterCreate',
              requiresAuth: true,
              permission: 'hr.payroll.master.create',
              breadcrumb: 'Create Payroll Master'
            }
          },
          {
            path: 'master/:id/detail',
            name: 'payrollMasterDetail',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-master/PayrollMasterDetail.vue'),
            props: true,
            meta: {
              title: 'routes.payrollMasterDetail',
              requiresAuth: true,
              permission: 'hr.payroll.master.view',
              breadcrumb: 'Payroll Master Detail'
            }
          },
          {
            path: 'master/bulk',
            name: 'payrollMasterBulk',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-master/PayrollMasterBulk.vue'),
            meta: {
              title: 'routes.payrollMasterBulk',
              requiresAuth: true,
              permission: 'hr.payroll.master.bulk',
              breadcrumb: 'Bulk Payroll Operations'
            }
          },
          {
            path: 'master/approval',
            name: 'payrollMasterApproval',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-master/PayrollMasterApproval.vue'),
            meta: {
              title: 'routes.payrollMasterApproval',
              requiresAuth: true,
              permission: 'hr.payroll.master.approve',
              breadcrumb: 'Payroll Master Approval'
            }
          },

          // Payroll Calculations Routes
          {
            path: 'calculations',
            name: 'payrollCalculationsList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-calculations/PayrollCalculationsList.vue'),
            meta: {
              title: 'routes.payrollCalculationsList',
              requiresAuth: true,
              permission: 'hr.payroll.calculations.view',
              breadcrumb: 'Payroll Calculations'
            }
          },
          {
            path: 'calculations/run',
            name: 'payrollCalculationsRun',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-calculations/PayrollCalculationsRun.vue'),
            meta: {
              title: 'routes.payrollCalculationsRun',
              requiresAuth: true,
              permission: 'hr.payroll.calculations.run',
              breadcrumb: 'Run Payroll Calculations'
            }
          },
          {
            path: 'calculations/review',
            name: 'payrollCalculationsReview',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-calculations/PayrollCalculationsReview.vue'),
            meta: {
              title: 'routes.payrollCalculationsReview',
              requiresAuth: true,
              permission: 'hr.payroll.calculations.review',
              breadcrumb: 'Review Calculations'
            }
          },
          {
            path: 'calculations/approve',
            name: 'payrollCalculationsApprove',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-calculations/PayrollCalculationsApprove.vue'),
            meta: {
              title: 'routes.payrollCalculationsApprove',
              requiresAuth: true,
              permission: 'hr.payroll.calculations.approve',
              breadcrumb: 'Approve Calculations'
            }
          },

          // Payroll Periods Routes
          {
            path: 'periods',
            name: 'payrollPeriodsList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-periods/PayrollPeriodsList.vue'),
            meta: {
              title: 'routes.payrollPeriodsList',
              requiresAuth: true,
              permission: 'hr.payroll.periods.view',
              breadcrumb: 'Payroll Periods'
            }
          },
          {
            path: 'periods/create',
            name: 'payrollPeriodsCreate',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-periods/PayrollPeriodsCreate.vue'),
            meta: {
              title: 'routes.payrollPeriodsCreate',
              requiresAuth: true,
              permission: 'hr.payroll.periods.create',
              breadcrumb: 'Create Payroll Period'
            }
          },
          {
            path: 'periods/calendar',
            name: 'payrollPeriodsCalendar',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-periods/PayrollPeriodsCalendar.vue'),
            meta: {
              title: 'routes.payrollPeriodsCalendar',
              requiresAuth: true,
              permission: 'hr.payroll.periods.view',
              breadcrumb: 'Payroll Calendar'
            }
          },
          {
            path: 'periods/:id/close',
            name: 'payrollPeriodsClose',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-periods/PayrollPeriodsClose.vue'),
            props: true,
            meta: {
              title: 'routes.payrollPeriodsClose',
              requiresAuth: true,
              permission: 'hr.payroll.periods.close',
              breadcrumb: 'Close Payroll Period'
            }
          },

          // Payroll Deductions Routes
          {
            path: 'deductions',
            name: 'payrollDeductionsList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-deductions/PayrollDeductionsList.vue'),
            meta: {
              title: 'routes.payrollDeductionsList',
              requiresAuth: true,
              permission: 'hr.payroll.deductions.view',
              breadcrumb: 'Payroll Deductions'
            }
          },
          {
            path: 'deductions/create',
            name: 'payrollDeductionsCreate',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-deductions/PayrollDeductionsCreate.vue'),
            meta: {
              title: 'routes.payrollDeductionsCreate',
              requiresAuth: true,
              permission: 'hr.payroll.deductions.create',
              breadcrumb: 'Create Deduction'
            }
          },

          // Payroll Adjustments Routes
          {
            path: 'adjustments',
            name: 'payrollAdjustmentsList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-adjustments/PayrollAdjustmentsList.vue'),
            meta: {
              title: 'routes.payrollAdjustmentsList',
              requiresAuth: true,
              permission: 'hr.payroll.adjustments.view',
              breadcrumb: 'Payroll Adjustments'
            }
          },
          {
            path: 'adjustments/create',
            name: 'payrollAdjustmentsCreate',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-adjustments/PayrollAdjustmentsCreate.vue'),
            meta: {
              title: 'routes.payrollAdjustmentsCreate',
              requiresAuth: true,
              permission: 'hr.payroll.adjustments.create',
              breadcrumb: 'Create Adjustment'
            }
          },
          {
            path: 'adjustments/review',
            name: 'payrollAdjustmentsReview',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-adjustments/PayrollAdjustmentsReview.vue'),
            meta: {
              title: 'routes.payrollAdjustmentsReview',
              requiresAuth: true,
              permission: 'hr.payroll.adjustments.review',
              breadcrumb: 'Review Adjustments'
            }
          },
          {
            path: 'adjustments/approve',
            name: 'payrollAdjustmentsApprove',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-adjustments/PayrollAdjustmentsApprove.vue'),
            meta: {
              title: 'routes.payrollAdjustmentsApprove',
              requiresAuth: true,
              permission: 'hr.payroll.adjustments.approve',
              breadcrumb: 'Approve Adjustments'
            }
          },

          // Payroll Tax Routes
          {
            path: 'tax',
            name: 'payrollTaxList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-tax/PayrollTaxList.vue'),
            meta: {
              title: 'routes.payrollTaxList',
              requiresAuth: true,
              permission: 'hr.payroll.tax.view',
              breadcrumb: 'Payroll Tax'
            }
          },

          // Payroll Reports Routes
          {
            path: 'reports',
            name: 'payrollReportsList',
            component: () => import('@/modules/hr/payrollmanagement/views/payroll-reports/PayrollReportsList.vue'),
            meta: {
              title: 'routes.payrollReportsList',
              requiresAuth: true,
              permission: 'hr.payroll.reports.view',
              breadcrumb: 'Payroll Reports'
            }
          }
        ]
      },

      // Contract Worker Management Routes
      {
        path: 'contractworkermanagement',
        name: 'contractWorkerManagement',
        redirect: { name: 'contractWorkerDashboard' },
        meta: {
          title: 'routes.contractWorkerManagement',
          requiresAuth: true,
          breadcrumb: 'Contract Worker Management'
        },
        children: [
          {
            path: 'dashboard',
            name: 'contractWorkerDashboard',
            component: () => import('@/modules/hr/contractworkermanagement/contractWorkers/components/ContractWorkerDashboard.vue'),
            meta: {
              title: 'routes.contractWorkerDashboard',
              requiresAuth: true,
              permission: 'hr.contract.worker.dashboard.view',
              breadcrumb: 'Contract Worker Dashboard'
            }
          },
          {
            path: 'workers',
            name: 'contractWorkers',
            component: () => import('@/modules/hr/contractworkermanagement/contractWorkers/components/ContractWorkerList.vue'),
            meta: {
              title: 'routes.contractWorkers',
              requiresAuth: true,
              permission: 'hr.contract.worker.view',
              breadcrumb: 'Contract Workers'
            }
          },
          {
            path: 'contracts',
            name: 'contracts',
            component: () => import('@/modules/hr/contractworkermanagement/contracts/components/ContractList.vue'),
            meta: {
              title: 'routes.contracts',
              requiresAuth: true,
              permission: 'hr.contract.view',
              breadcrumb: 'Contracts'
            }
          },
          // {
          //   path: 'analytics',
          //   name: 'contractAnalytics',
          //   component: () => import('@/modules/hr/contractworkermanagement/contractanalytics/components/ContractAnalyticsDashboard.vue'),
          //   meta: {
          //     title: 'routes.contractAnalytics',
          //     requiresAuth: true,
          //     permission: 'hr.contract.analytics.view',
          //     breadcrumb: 'Contract Analytics'
          //   }
          // }
        ]
      },

      // Performance Management Routes
      {
        path: 'performancemanagement',
        name: 'performanceManagement',
        redirect: { name: 'performanceReviewDashboard' },
        meta: {
          title: 'routes.performanceManagement',
          requiresAuth: true,
          breadcrumb: 'Performance Management'
        },
        children: [
          // Performance Reviews Routes
          {
            path: 'reviews',
            name: 'performanceReviews',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewList.vue'),
            meta: {
              title: 'routes.performanceReviews',
              requiresAuth: true,
              permission: 'hr.performance.reviews.view',
              breadcrumb: 'Performance Reviews'
            }
          },
          {
            path: 'reviews/dashboard',
            name: 'performanceReviewDashboard',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewDashboard.vue'),
            meta: {
              title: 'routes.performanceReviewDashboard',
              requiresAuth: true,
              permission: 'hr.performance.reviews.view',
              breadcrumb: 'Performance Review Dashboard'
            }
          },
          {
            path: 'reviews/create',
            name: 'createPerformanceReview',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewForm.vue'),
            meta: {
              title: 'routes.createPerformanceReview',
              requiresAuth: true,
              permission: 'hr.performance.reviews.create',
              breadcrumb: 'Create Performance Review'
            }
          },
          {
            path: 'reviews/:id/edit',
            name: 'editPerformanceReview',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewForm.vue'),
            props: true,
            meta: {
              title: 'routes.editPerformanceReview',
              requiresAuth: true,
              permission: 'hr.performance.reviews.edit',
              breadcrumb: 'Edit Performance Review'
            }
          },
          {
            path: 'reviews/:id/view',
            name: 'viewPerformanceReview',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewView.vue'),
            props: true,
            meta: {
              title: 'routes.viewPerformanceReview',
              requiresAuth: true,
              permission: 'hr.performance.reviews.view',
              breadcrumb: 'View Performance Review'
            }
          },
          {
            path: 'reviews/:id/scoring',
            name: 'performanceReviewScoring',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewScoring.vue'),
            props: true,
            meta: {
              title: 'routes.performanceReviewScoring',
              requiresAuth: true,
              permission: 'hr.performance.reviews.score',
              breadcrumb: 'Performance Review Scoring'
            }
          },
          {
            path: 'reviews/:id/approval',
            name: 'performanceReviewApproval',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceReviewApproval.vue'),
            props: true,
            meta: {
              title: 'routes.performanceReviewApproval',
              requiresAuth: true,
              permission: 'hr.performance.reviews.approve',
              breadcrumb: 'Performance Review Approval'
            }
          },
          {
            path: 'goals-tracker',
            name: 'performanceGoalsTracker',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceGoalsTracker.vue'),
            meta: {
              title: 'routes.performanceGoalsTracker',
              requiresAuth: true,
              permission: 'hr.performance.goals.view',
              breadcrumb: 'Goals Tracker'
            }
          },
          {
            path: 'improvement-plans',
            name: 'performanceImprovementPlans',
            component: () => import('@/modules/hr/performancemanagement/performanceReviews/components/PerformanceImprovementPlan.vue'),
            meta: {
              title: 'routes.performanceImprovementPlans',
              requiresAuth: true,
              permission: 'hr.performance.improvement.view',
              breadcrumb: 'Performance Improvement Plans'
            }
          },

          // Performance Metrics Routes
          {
            path: 'metrics',
            name: 'performanceMetrics',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsList.vue'),
            meta: {
              title: 'routes.performanceMetrics',
              requiresAuth: true,
              permission: 'hr.performance.metrics.view',
              breadcrumb: 'Performance Metrics'
            }
          },
          {
            path: 'metrics/dashboard',
            name: 'performanceMetricsDashboard',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsDashboard.vue'),
            meta: {
              title: 'routes.performanceMetricsDashboard',
              requiresAuth: true,
              permission: 'hr.performance.metrics.view',
              breadcrumb: 'Performance Metrics Dashboard'
            }
          },
          {
            path: 'metrics/create',
            name: 'createPerformanceMetric',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsForm.vue'),
            meta: {
              title: 'routes.createPerformanceMetric',
              requiresAuth: true,
              permission: 'hr.performance.metrics.create',
              breadcrumb: 'Create Performance Metric'
            }
          },
          {
            path: 'metrics/:id/edit',
            name: 'editPerformanceMetric',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsForm.vue'),
            props: true,
            meta: {
              title: 'routes.editPerformanceMetric',
              requiresAuth: true,
              permission: 'hr.performance.metrics.edit',
              breadcrumb: 'Edit Performance Metric'
            }
          },
          {
            path: 'metrics/:id/view',
            name: 'viewPerformanceMetric',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsView.vue'),
            props: true,
            meta: {
              title: 'routes.viewPerformanceMetric',
              requiresAuth: true,
              permission: 'hr.performance.metrics.view',
              breadcrumb: 'View Performance Metric'
            }
          },
          {
            path: 'metrics/chart',
            name: 'performanceMetricsChart',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsChart.vue'),
            meta: {
              title: 'routes.performanceMetricsChart',
              requiresAuth: true,
              permission: 'hr.performance.metrics.view',
              breadcrumb: 'Performance Metrics Chart'
            }
          },
          {
            path: 'metrics/targets',
            name: 'performanceMetricsTargets',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsTargets.vue'),
            meta: {
              title: 'routes.performanceMetricsTargets',
              requiresAuth: true,
              permission: 'hr.performance.metrics.targets',
              breadcrumb: 'Performance Targets'
            }
          },
          {
            path: 'metrics/benchmark',
            name: 'performanceMetricsBenchmark',
            component: () => import('@/modules/hr/performancemanagement/performanceMetrics/components/PerformanceMetricsBenchmark.vue'),
            meta: {
              title: 'routes.performanceMetricsBenchmark',
              requiresAuth: true,
              permission: 'hr.performance.metrics.benchmark',
              breadcrumb: 'Performance Benchmark'
            }
          },

        ]
      },

      // Training Management Routes
      {
        path: 'trainingmanagement',
        name: 'trainingManagement',
        redirect: { name: 'assessmentsList' },
        meta: {
          title: 'routes.trainingManagement',
          requiresAuth: true,
          breadcrumb: 'Training Management'
        },
        children: [
          // Training Programs
          {
            path: 'programs',
            name: 'trainingProgramRecommendations',
            component: () => import('@/modules/hr/trainingmanagement/trainingPrograms/components/TrainingProgramRecommendations.vue'),
            meta: {
              title: 'routes.trainingProgramRecommendations',
              requiresAuth: true,
              permission: 'hr.training.programs.view',
              breadcrumb: 'Training Program Recommendations'
            }
          },

          // Assessments & Competencies
          {
            path: 'assessments',
            name: 'assessmentsList',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/AssessmentList.vue'),
            meta: {
              title: 'routes.assessmentsList',
              requiresAuth: true,
              permission: 'hr.training.assessments.view',
              breadcrumb: 'Assessments'
            }
          },
          {
            path: 'assessments/create',
            name: 'createAssessment',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/AssessmentForm.vue'),
            meta: {
              title: 'routes.createAssessment',
              requiresAuth: true,
              permission: 'hr.training.assessments.create',
              breadcrumb: 'Create Assessment'
            }
          },
          {
            path: 'assessments/:id/edit',
            name: 'editAssessment',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/AssessmentForm.vue'),
            props: true,
            meta: {
              title: 'routes.editAssessment',
              requiresAuth: true,
              permission: 'hr.training.assessments.edit',
              breadcrumb: 'Edit Assessment'
            }
          },
          {
            path: 'assessments/:id/view',
            name: 'viewAssessment',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/AssessmentView.vue'),
            props: true,
            meta: {
              title: 'routes.viewAssessment',
              requiresAuth: true,
              permission: 'hr.training.assessments.view',
              breadcrumb: 'View Assessment'
            }
          },
          {
            path: 'assessments/:id/take',
            name: 'takeAssessment',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/AssessmentTaking.vue'),
            props: true,
            meta: {
              title: 'routes.takeAssessment',
              requiresAuth: true,
              permission: 'hr.training.assessments.take',
              breadcrumb: 'Take Assessment'
            }
          },

          // Competencies
          {
            path: 'competencies',
            name: 'competenciesList',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CompetencyList.vue'),
            meta: {
              title: 'routes.competenciesList',
              requiresAuth: true,
              permission: 'hr.training.competencies.view',
              breadcrumb: 'Competencies'
            }
          },
          {
            path: 'competencies/create',
            name: 'createCompetency',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CompetencyForm.vue'),
            meta: {
              title: 'routes.createCompetency',
              requiresAuth: true,
              permission: 'hr.training.competencies.create',
              breadcrumb: 'Create Competency'
            }
          },
          {
            path: 'competencies/:id/edit',
            name: 'editCompetency',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CompetencyForm.vue'),
            props: true,
            meta: {
              title: 'routes.editCompetency',
              requiresAuth: true,
              permission: 'hr.training.competencies.edit',
              breadcrumb: 'Edit Competency'
            }
          },
          {
            path: 'competencies/:id/view',
            name: 'viewCompetency',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CompetencyView.vue'),
            props: true,
            meta: {
              title: 'routes.viewCompetency',
              requiresAuth: true,
              permission: 'hr.training.competencies.view',
              breadcrumb: 'View Competency'
            }
          },
          {
            path: 'competencies/matrix',
            name: 'competencyMatrix',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CompetencyMatrix.vue'),
            meta: {
              title: 'routes.competencyMatrix',
              requiresAuth: true,
              permission: 'hr.training.competencies.view',
              breadcrumb: 'Competency Matrix'
            }
          },
          {
            path: 'skill-gap-analysis',
            name: 'skillGapAnalysis',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/SkillGapAnalysis.vue'),
            meta: {
              title: 'routes.skillGapAnalysis',
              requiresAuth: true,
              permission: 'hr.training.skillgap.view',
              breadcrumb: 'Skill Gap Analysis'
            }
          },
          {
            path: 'certification-tracker',
            name: 'certificationTracker',
            component: () => import('@/modules/hr/trainingmanagement/assessmentsCompetencies/components/CertificationTracker.vue'),
            meta: {
              title: 'routes.certificationTracker',
              requiresAuth: true,
              permission: 'hr.training.certifications.view',
              breadcrumb: 'Certification Tracker'
            }
          },

          // Development Plans
          {
            path: 'development-plans',
            name: 'developmentPlansList',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanList.vue'),
            meta: {
              title: 'routes.developmentPlansList',
              requiresAuth: true,
              permission: 'hr.training.development.view',
              breadcrumb: 'Development Plans'
            }
          },
          {
            path: 'development-plans/create',
            name: 'createDevelopmentPlan',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanForm.vue'),
            meta: {
              title: 'routes.createDevelopmentPlan',
              requiresAuth: true,
              permission: 'hr.training.development.create',
              breadcrumb: 'Create Development Plan'
            }
          },
          {
            path: 'development-plans/:id/edit',
            name: 'editDevelopmentPlan',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanForm.vue'),
            props: true,
            meta: {
              title: 'routes.editDevelopmentPlan',
              requiresAuth: true,
              permission: 'hr.training.development.edit',
              breadcrumb: 'Edit Development Plan'
            }
          },
          {
            path: 'development-plans/:id/view',
            name: 'viewDevelopmentPlan',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanView.vue'),
            props: true,
            meta: {
              title: 'routes.viewDevelopmentPlan',
              requiresAuth: true,
              permission: 'hr.training.development.view',
              breadcrumb: 'View Development Plan'
            }
          },
          {
            path: 'development-plans/:id/progress',
            name: 'developmentPlanProgress',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanProgress.vue'),
            props: true,
            meta: {
              title: 'routes.developmentPlanProgress',
              requiresAuth: true,
              permission: 'hr.training.development.view',
              breadcrumb: 'Development Plan Progress'
            }
          },
          {
            path: 'development-plans/goals',
            name: 'developmentPlanGoals',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanGoals.vue'),
            meta: {
              title: 'routes.developmentPlanGoals',
              requiresAuth: true,
              permission: 'hr.training.development.goals',
              breadcrumb: 'Development Plan Goals'
            }
          },
          {
            path: 'development-plans/career-path',
            name: 'developmentPlanCareerPath',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanCareerPath.vue'),
            meta: {
              title: 'routes.developmentPlanCareerPath',
              requiresAuth: true,
              permission: 'hr.training.development.career',
              breadcrumb: 'Career Path Planning'
            }
          },
          {
            path: 'development-plans/mentorship',
            name: 'developmentPlanMentorship',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanMentorship.vue'),
            meta: {
              title: 'routes.developmentPlanMentorship',
              requiresAuth: true,
              permission: 'hr.training.development.mentorship',
              breadcrumb: 'Mentorship Program'
            }
          },
          {
            path: 'development-plans/analytics',
            name: 'developmentPlanAnalytics',
            component: () => import('@/modules/hr/trainingmanagement/developmentPlans/components/DevelopmentPlanAnalytics.vue'),
            meta: {
              title: 'routes.developmentPlanAnalytics',
              requiresAuth: true,
              permission: 'hr.training.development.analytics',
              breadcrumb: 'Development Plan Analytics'
            }
          }
        ]
      },

      // Leave Management Routes
      ...leaveAccrualRoutes,
      ...leaveApprovalWorkflowRoutes,
      ...leaveCalendarRoutes,
      ...leaveReportsRoutes,

      // // Settings Routes
      // {
      //   path: 'settings',
      //   name: 'hrSettings',
      //   component: () => import('@/modules/hr/settings/components/HRSettings.vue'),
      //   meta: {
      //     title: 'routes.hrSettings',
      //     requiresAuth: true,
      //     permission: 'hr.settings.view',
      //     breadcrumb: 'HR Settings'
      //   }
      // },

      // // Bulk Operations Routes
      // {
      //   path: 'bulk-import',
      //   name: 'hrBulkImport',
      //   component: () => import('@/modules/hr/common/components/BulkImportView.vue'),
      //   meta: {
      //     title: 'routes.hrBulkImport',
      //     requiresAuth: true,
      //     permission: 'hr.bulk.import',
      //     breadcrumb: 'Bulk Import'
      //   }
      // },

      // // Approval Management Routes
      // {
      //   path: 'approval/workflow',
      //   name: 'hrApprovalWorkflow',
      //   component: () => import('@/modules/hr/approval/components/ApprovalWorkflow.vue'),
      //   meta: {
      //     title: 'HR Approval Workflow',
      //     requiresAuth: true,
      //     permission: 'hr.approval.view',
      //     breadcrumb: 'Approval Workflow'
      //   }
      // }
    ]
  }
]
